import { type PropsWithChildren, forwardRef } from "react";

import type { RadioButtonProps } from "./RadioButton.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const RadioButton = forwardRef<
  HTMLInputElement,
  PropsWithChildren<RadioButtonProps>
>(({ onChange, ...radioButtonProps }, forwardedRef) => {
  return (
    <input
      ref={forwardedRef}
      type="radio"
      className={cn(
        "bg-snow h-5 w-5 rounded-full border-neutral-500 text-primary transition-all duration-200 checked:border-primary checked:bg-primary focus:outline focus:outline-1 focus:outline-primary focus:ring-0 focus:ring-offset-0 disabled:pointer-events-none disabled:opacity-50",
      )}
      onChange={(event) => {
        if (onChange) onChange(event.currentTarget.checked);
      }}
      {...radioButtonProps}
    />
  );
});

RadioButton.displayName = "RadioButton";

export default RadioButton;
